// src/hooks/useAuth.js
import { useState, useEffect } from 'react';
import { API_BASE } from '../api/config';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (data.success && data.user) {
        setUser(data.user);
        return true;
      } else {
        alert(data.message || '登录失败');
        return false;
      }
    } catch (err) {
      console.error('登录失败:', err);
      if (err.name === 'TypeError' && err.message.includes('fetch')) {
        alert('⚠️ 网络连接失败\n请检查：\n• 是否禁用后台网络\n• 是否使用了广告拦截插件\n• 尝试切换 4G/WiFi');
      } else {
        alert('未知错误：' + (err.message || '请反馈截图'));
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await fetch(`${API_BASE}/auth.php`, { method: 'DELETE', credentials: 'include' });
    } catch (err) {
      console.error('登出失败:', err);
    }
    setUser(null);
  };

  const checkAuthStatus = async () => {
    try {
      const res = await fetch(`${API_BASE}/auth.php`, { credentials: 'include' });
      if (res.ok) {
        const data = await res.json();
        if (data.user) {
          setUser(data.user);
          return true;
        }
      }
    } catch (err) {
      console.error('验证登录状态失败:', err);
    }
    return false;
  };

  return { user, login, logout, loading, checkAuthStatus };
};